import { LocationHours } from 'js/components/LocationHours/index.js';

export class LocationHoursMod extends LocationHours {
  processTodayHours() {
    super.processTodayHours();
    for (let isToday of this.element.querySelectorAll('.js-is-today')) {
      for (let instance of isToday.querySelectorAll('.js-location-hours-interval-instance')) {
        let start = parseInt(instance.dataset.openIntervalStart);
        let end = parseInt(instance.dataset.openIntervalEnd);
        let today = new Date();
        let currentHour = (today.getHours()*100) + today.getMinutes();
        if ((start !== end) && ((start !== 0) || (end !== 0))) { // Not Open 24 hours
          if (start < end) {
            if ((currentHour > end) && (end !== 0)) {
              isToday.classList.add('js-is-closed');
              return;
            }
          }
        }
      }
      for (let instance of isToday.querySelectorAll('.js-is-today .c-location-hours-today-day-status')) {
        let start = parseInt(instance.dataset.openIntervalStart);
        let end = parseInt(instance.dataset.openIntervalEnd);
        if (isNaN(start) && isNaN(end)) {
          instance.classList.add('js-is-closed');
        }
      }
    }
  }
}

LocationHoursMod.initClass();
